export enum AnalyticsAdminLevelsEnum {
  FEDERAL = 'Федеральный уровень',
  REGION = 'Региональный уровень',
  MUNICIPAL = 'Муниципальный уровень',
  NOTSPECIFIED = 'Уровень не указан',
}
